// utils/config.ts
export const getConfig = () => {
  // Intenta diferentes formas de obtener las variables de entorno
  const apiUrl =
    (window as any).__NUXT__?.config?.public?.apiUrl || import.meta.env.VITE_API_URL || 'http://localhost:8080/api'

  return {
    apiUrl,
  }
}
